import { AppWizardComponent } from '../components/app-wizard/app-wizard.component';
import { LayoutWizardDialog } from '../components/wizards/layout/layout.wizard.dialog';
import { PropertyDialogComponent } from '../components/app-wizard/property-dialog.component';

export const APP_WIZARDS = [
    LayoutWizardDialog,
    AppWizardComponent,
    PropertyDialogComponent
];
